import { faUserTag } from '@fortawesome/pro-regular-svg-icons/faUserTag'
import { Box, Text, NumberInput } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Badge, CollapsibleCard, Icon } from '@flecto/ui'

import { useFormContext } from './FormCustomer'

export function Discount() {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  const form = useFormContext()

  const discount = form.getInputProps('default_discount_amount').value || 0
  const hasValue = Boolean(discount)

  return (
    <Box mb='lg'>
      <CollapsibleCard>
        <CollapsibleCard.Title>
          {t('add_customer.discount')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          {t('add_customer.discount_description')}
        </CollapsibleCard.Description>
        <CollapsibleCard.Icon withCircleBackground icon={faUserTag} />
        <CollapsibleCard.RightSection>
          <Badge
            color={hasValue ? 'green' : 'gray'}
            leftSection={<Icon icon={faUserTag} />}
          >
            {hasValue ? `${discount}%` : '0%'}
          </Badge>
        </CollapsibleCard.RightSection>
        <CollapsibleCard.Content>
          <NumberInput
            mb='xs'
            label={t('add_customer.discount')}
            leftSection={<Text c='black'>%</Text>}
            value={Number(discount)}
            min={0}
            max={100}
            maw={200}
            onChange={(value) => {
              form.setFieldValue('default_discount_amount', Number(value))
            }}
          />
        </CollapsibleCard.Content>
      </CollapsibleCard>
    </Box>
  )
}
